import React from 'react';
export function BonusSection() {
  return <section className="bg-[#0a0e27] py-4 md:py-6 px-4 font-sans" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        {/* Header */}
        <div className="text-center mb-4" data-id="element-21">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-1" data-id="element-22">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto mb-2" data-id="element-23">
            Para que tengas respaldo profesional y herramientas listas para
            implementar, incluimos 2 bonus estratégicos:
          </p>
          <div className="inline-block bg-gradient-to-r from-red-600 to-orange-500 text-white font-bold px-5 py-1.5 rounded-md shadow-[0_0_15px_rgba(239,68,68,0.5)] border border-red-400" data-id="element-24">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        {/* Bonus Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4 max-w-4xl mx-auto" data-id="element-25">
          {/* Bonus 1 */}
          <div className="bg-[#111638] rounded-lg p-3 border border-gray-800 border-l-4 border-l-red-500 relative overflow-hidden flex flex-col h-full" data-id="element-26">
            <div className="absolute top-0 right-1 text-7xl font-black text-red-500/10 select-none pointer-events-none leading-none mt-1" data-id="element-27">
              01
            </div>
            <div className="mb-1.5" data-id="element-28">
              <span className="bg-red-500 text-white text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-29">
                Bono #01
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-1 relative z-10" data-id="element-30">
              📅 Planificación Anual Lista
            </h3>
            <p className="text-gray-400 text-sm mb-2 flex-grow relative z-10" data-id="element-31">
              Organizá todo el año escolar con una planificación clara,
              adaptable y lista para presentar.
            </p>
            <div className="flex items-center justify-between mt-auto relative z-10 border-t border-gray-800 pt-2" data-id="element-32">
              <span className="text-gray-500 line-through text-sm" data-id="element-33">
                Valor $15.000
              </span>
              <span className="bg-[#22c55e] text-white text-sm font-bold px-3 py-0.5 rounded-md" data-id="element-34">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-[#111638] rounded-lg p-3 border border-gray-800 border-l-4 border-l-blue-500 relative overflow-hidden flex flex-col h-full" data-id="element-35">
            <div className="absolute top-0 right-1 text-7xl font-black text-blue-500/10 select-none pointer-events-none leading-none mt-1" data-id="element-36">
              02
            </div>
            <div className="mb-1.5" data-id="element-37">
              <span className="bg-blue-500 text-white text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-38">
                Bono #02
              </span>
            </div>
            <h3 className="text-xl font-bold text-white mb-1 relative z-10" data-id="element-39">
              🧠 Banco de Dinámicas Psicológicas para el Aula
            </h3>
            <p className="text-gray-400 text-sm mb-2 flex-grow relative z-10" data-id="element-40">
              Mejorá la participación, generá impacto y facilitá clases más
              activas.
            </p>
            <div className="flex items-center justify-between mt-auto relative z-10 border-t border-gray-800 pt-2" data-id="element-41">
              <span className="text-gray-500 line-through text-sm" data-id="element-42">
                Valor $12.000
              </span>
              <span className="bg-[#22c55e] text-white text-sm font-bold px-3 py-0.5 rounded-md" data-id="element-43">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        {/* Total Value Box */}
        <div className="max-w-sm mx-auto bg-[#111638] border border-gray-700 rounded-lg p-3 text-center shadow-2xl" data-id="element-44">
          <p className="text-gray-400 text-sm mb-0.5" data-id="element-45">
            Valor total de los 2 bonus:
          </p>
          <p className="text-2xl font-bold text-red-500 line-through decoration-2 mb-1" data-id="element-46">
            $27.000
          </p>
          <p className="text-white font-bold text-base mb-0.5" data-id="element-47">
            Hoy te los llevás por:
          </p>
          <p className="text-6xl font-black text-[#22c55e] mb-1 drop-shadow-[0_0_10px_rgba(34,197,94,0.3)]" data-id="element-48">
            $0
          </p>
          <p className="text-yellow-400 font-bold text-sm" data-id="element-49">
            ✨ Incluidos GRATIS con tu compra de hoy ✨
          </p>
        </div>
      </div>
    </section>;
}